(function () {
  'use strict';

  function initialize(element) {
    if (!element || element.dataset.loaded === 'true' || !element.dataset.url) return;
    element.dataset.loaded = 'true';

    fetch(element.dataset.url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendation request failed.');
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var replacement = parsed.querySelector('[data-product-recommendations]');
        if (!replacement || !replacement.innerHTML.trim()) {
          element.remove();
          return;
        }
        element.innerHTML = replacement.innerHTML;
      })
      .catch(function () {
        element.remove();
      });
  }

  function initializeAll(scope) {
    (scope || document).querySelectorAll('[data-product-recommendations]').forEach(initialize);
  }

  initializeAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
